/**
 * OPEN-153 / DEC-354 — a job's total paused time as dispatch and review read it
 * (Corbin: "Paused 1h 12m total, 2 pauses").
 *
 * The numbers come from GET /v1/jobs/:id `pausedSeconds` + `pauseCount`, which the server
 * derives from the timeclock event chain on every read — never stored, never an
 * accumulator (§11). This only formats them.
 */

function formatSpan(seconds: number): string {
  if (seconds < 60) return 'under 1m';
  const totalMinutes = Math.round(seconds / 60);
  const h = Math.floor(totalMinutes / 60);
  const m = totalMinutes % 60;
  return h > 0 ? `${h.toString()}h ${m.toString()}m` : `${m.toString()}m`;
}

/**
 * "Paused 1h 12m total, 2 pauses" — "Never paused" for a job with no pause, and "—" when
 * the server did not send the fields (an older API).
 */
export function formatPausedTotal(
  pausedSeconds: number | null | undefined,
  pauseCount: number | null | undefined,
): string {
  if (pausedSeconds == null || pauseCount == null) return '—';
  if (pauseCount === 0) return 'Never paused';
  const pauses = pauseCount === 1 ? '1 pause' : `${pauseCount.toString()} pauses`;
  return `Paused ${formatSpan(pausedSeconds)} total, ${pauses}`;
}
